import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const sunheroTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.sunhero,
  logoUrl: "https://cdn.nemuru.com/assets/logos/sunhero-logo.svg",
  palette: {
    primary: {
      main: "#00624f",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#fed200",
      contrastText: "#3c3c3b",
    },
    dark: {
      main: "#f7faf9",
      contrastText: "#353430",
      accent: "#00624f",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#3c3c3b",
      primary: "#3c3c3b",
      secondary: "#6b6b6b",
    },
    status: {
      active: "#00a777",
      approved: "#00624f",
      analysing: "#fed200",
      sent: "#003862",
      cancelled: "#d8d8d8",
      denied: "#f1595c",
    },
    info: {
      main: "#0094ed",
      contrastText: "#ffffff",
      light: "#cde9fd",
    },
    warning: {
      main: "#ffe77c",
      contrastText: "#3c3c3b",
      light: "#ffffad",
    },
    success: {
      main: "#00774b",
      contrastText: "#ffffff",
      light: "rgba(0, 119, 75,0.3)",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f7faf9",
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 16,
  },
  typography: {
    fontFamily: "Helvetica, Arial, sans-serif",
  },
};
